import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import {
    Home,
    BusinessCenter,
    PeopleAlt,
    ChatBubbleOutline,
    CalendarViewMonth,
    Search,
    BarChart,
    AccountTree,
    Route as RouteIcon,
    Description,
    EventNote,
    Language,
    Store,
    PeopleOutline,
    HelpCenter,
    EventAvailable,
    People,
    WatchLater,
    AttachMoney,
    Message,
    CreditCard,
} from '@mui/icons-material';
import { useUserContext } from 'UserContext';
import { RLayout } from './RLayout';
import { RNavItem, AppMode } from './RLayoutSidebar';
import { RNCVacanciesCard } from './RNCVacanciesCard';

const RECRUIT_NAV: RNavItem[] = [
    { label: 'Home', icon: <Home />, route: '/recruit' },
    { label: 'Positions', icon: <BusinessCenter />, route: '/recruit/positions' },
    { label: 'Applications', icon: <PeopleAlt />, route: '/recruit/applications' },
    { label: 'Messenger', icon: <ChatBubbleOutline />, route: '/recruit/messenger' },
    { label: 'Interviews', icon: <CalendarViewMonth />, route: '/recruit/interviews' },
    { label: 'Sourcing', icon: <Search />, route: '/recruit/sourcing' },
    { label: 'Reports', icon: <BarChart />, route: '/recruit/reports' },
];

const RECRUIT_SETTINGS_NAV: RNavItem[] = [
    { label: 'Position Templates', icon: <AccountTree />, route: '/recruit/settings/templates' },
    { label: 'Screening Questions', icon: <HelpCenter />, route: '/recruit/settings/screening-questions' },
    { label: 'Workflows', icon: <RouteIcon />, route: '/recruit/settings/workflows' },
    { label: 'Communication Templates', icon: <Description />, route: '/recruit/settings/communication' },
    { label: 'Interview Settings', icon: <EventNote />, route: '/recruit/settings/interviews' },
    { label: 'Careers Page', icon: <Language />, route: '/recruit/settings/careers' },
    { label: 'Billing', icon: <CreditCard />, route: '/recruit/settings/billing' },
];

const RECRUIT_BOTTOM_NAV: RNavItem[] = [
    { label: 'Manage Centers', icon: <Store />, route: '/recruit/manage-centers' },
    { label: 'Manage Users', icon: <PeopleOutline />, route: '/recruit/manage-users' },
];

const SUBS_NAV: RNavItem[] = [
    { label: 'Home', icon: <Home />, route: '/home' },
    { label: 'My Jobs', icon: <EventAvailable />, route: '/jobs' },
    { label: 'My Staff', icon: <People />, route: '/providers' },
    { label: 'Timesheets', icon: <WatchLater />, route: '/timesheets' },
    { label: 'Payments', icon: <AttachMoney />, route: '/payments' },
    { label: 'Messages', icon: <Message />, route: '/messages' },
];

const SUBS_BOTTOM_NAV: RNavItem[] = [
    { label: 'Manage Centers', icon: <Store />, route: '/manage-centers' },
    { label: 'Manage Users', icon: <PeopleOutline />, route: '/manage-users' },
];

export function RecruitBusinessLayout({ children }: { children: React.ReactNode }) {
    const location = useLocation();
    const history = useHistory();
    const { user } = useUserContext();

    const currentMode: AppMode = location.pathname.startsWith('/recruit') ? 'recruit' : 'subs';
    const isRecruit = currentMode === 'recruit';

    const isNorthCarolinaCenter = user?.address?.some((addr) => addr.state === 'North Carolina') ?? false;
    const initials = user ? `${user.first_name[0] || ''}${user.last_name[0] || ''}`.toUpperCase() : '';

    const handleModeChange = (newMode: AppMode) => {
        if (newMode === 'recruit') {
            history.push('/recruit');
        } else {
            history.push('/home');
        }
    };

    return (
        <RLayout
            initials={initials}
            navItems={isRecruit ? RECRUIT_NAV : SUBS_NAV}
            bottomNavItems={isRecruit ? RECRUIT_BOTTOM_NAV : SUBS_BOTTOM_NAV}
            settingsNavItems={isRecruit ? RECRUIT_SETTINGS_NAV : undefined}
            modeToggle={{ mode: currentMode, onModeChange: handleModeChange }}
            extraBottomContent={isNorthCarolinaCenter ? <RNCVacanciesCard /> : undefined}
        >
            {children}
        </RLayout>
    );
}
